import { ComponentType } from 'react';

import type { WithContextProps } from '@atlaskit/analytics-next/withAnalyticsContext';
import type { InvitePeopleProps } from '@atlassian/invite-people/types';

import Loadable from '@townsquare/loadable';

const AkInvitePeople: ComponentType<InvitePeopleProps & WithContextProps> &
	LoadableExport.LoadableComponent = Loadable<InvitePeopleProps & WithContextProps, any>({
	loader: () => import(/* webpackChunkName: "ak-invite-people" */ '@atlassian/invite-people'),
	loading: () => null,
});

export default AkInvitePeople;
